export default __webpack_public_path__ + "static/media/cardetail2.3984261c.jpeg";